import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  padding: 0;
  width: 100%;
  padding: ${(props) => {
    return props.smallPadding ? '12px' : '16px';
  }};
  background: ${(props) => {
    return props.isReadStatus ? 'inherit' : color.orange6;
  }};
  .container_notification {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    column-gap: 12px;
  }
  .component_account_card_photo {
    min-width: 40px;
    width: 40x;
    height: 40px;
    overflow: hidden;
    img {
      background: white;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .ant-avatar {
      width: 40px;
      height: 40px;
      .ant-avatar-string {
        line-height: 40px;
        font-size: 16px;
        margin-left: 1px;
      }
    }
    .component_account_card_text {
      background-color: ${color.orange2};
    }
  }

  .component_notification_text {
    width: 100%;
    .component_notification_title {
      color: ${color.black2};
      .component_notification_title_bold {
        font-weight: 600;
      }
    }
    .component_notification_timer {
      width: 100%;
      color: ${color.orange1};
      position: relative;
      ::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 8px;
        width: 8px;
        background: ${color.orange1};
        border-radius: 100%;
        display: ${(props) => {
          return props.isReadStatus ? 'none' : 'block';
        }};
      }
    }
  }
`;

export default Wrapper;
